import React from "react";
import firebase from "../../firebase";
import { connect } from "react-redux";
import { setCurrentChannel, setPrivateChannel } from "../../actions";
import { Menu, Icon, Input, Container, Feed } from "semantic-ui-react";
import AddFriendButton from "./AddFriendButton";

class SearchUsersComponent extends React.Component {
  state = {
    user: this.props.currentUser,
    users: [],
    usersRef: firebase.database().ref("users"),
    presenceRef: firebase.database().ref("presence"),
    connectedRef: firebase.database().ref(".info/connected"),
    friends: [],
    blocked: [],
    searchTerm: "",
    searchLoading: false,
    searchResults: [],
  };

  componentDidMount() {
    if (this.state.user) {
      this.addListeners(this.state.user.uid);
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  removeListeners = () => {
    this.state.usersRef.off();
    this.state.usersRef.child(`${this.state.user.uid}/friends`).off();
    this.state.presenceRef.off();
    this.state.connectedRef.off();
  };

  handleSearchChange = (event) => {
    this.setState(
      {
        searchTerm: event.target.value,
        searchLoading: true,
      },
      () => this.handleSearchUsers()
    );
  };

  handleSearchUsers = () => {
    const usersCopy = [...this.state.users];
    const regex = new RegExp(this.state.searchTerm, "gi");
    const searchResults = usersCopy.reduce((acc, user) => {
      if (user.name && user.name.match(regex)) {
        acc.push(user);
      }
      return acc;
    }, []);
    this.setState({ searchResults });
    setTimeout(() => this.setState({ searchLoading: false }), 1000);
  };

  addListeners = (currentUserUid) => {
    let loadedUsers = [];
    this.state.usersRef.on("child_added", (snap) => {
      if (currentUserUid !== snap.key) {
        let user = snap.val();
        user["uid"] = snap.key;
        user["status"] = "offline";
        loadedUsers.push(user);
        this.setState({ users: loadedUsers });
      }
    });

    let loadedFriends = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/friends`)
      .on("child_added", (snap) => {
        if (currentUserUid !== snap.key) {
          let user = snap.val();
          user["uid"] = user.uid;
          user["added"] = false;
          user["key"] = snap.key;
          loadedFriends.push(user);
          this.setState({ friends: loadedFriends });
        }
      });

    loadedFriends = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/friends`)
      .on("child_removed", (snap) => {
        if (currentUserUid !== snap.key) {
          let user = snap.val();
          // console.log(user)
          user["uid"] = user.uid;
          loadedFriends = this.state.friends.filter((f) => f.uid !== user.uid);
          this.setState({ friends: loadedFriends });
        }
      });

    let blocked = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/blocked`)
      .on("child_added", (snap) => {
        if (currentUserUid !== snap.key) {
          let user = snap.val();
          user["uid"] = user.uid;
          user["added"] = false;
          user["key"] = snap.key;
          blocked.push(user);
          this.setState({ blocked: blocked });
        }
      });

    blocked = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/blocked`)
      .on("child_removed", (snap) => {
        if (currentUserUid !== snap.key) {
          let user = snap.val();
          // console.log(user)
          user["uid"] = user.uid;
          blocked = this.state.blocked.filter((f) => f.uid !== user.uid);
          this.setState({ blocked: blocked });
        }
      });

    this.state.connectedRef.on("value", (snap) => {
      if (snap.val() === true) {
        const ref = this.state.presenceRef.child(currentUserUid);
        ref.set(true);
        ref.onDisconnect().remove((err) => {
          if (err !== null) {
            console.error(err);
          }
        });
      }
    });

    this.state.presenceRef.on("child_added", (snap) => {
      if (currentUserUid !== snap.key) {
        this.addStatusToUser(snap.key);
      }
    });

    this.state.presenceRef.on("child_removed", (snap) => {
      if (currentUserUid !== snap.key) {
        this.addStatusToUser(snap.key, false);
      }
    });
  };

  addStatusToUser = (userId, connected = true) => {
    const updatedUsers = this.state.friends.reduce((acc, user) => {
      if (user.uid === userId) {
        user["status"] = `${connected ? "online" : "offline"}`;
      }
      return acc.concat(user);
    }, []);
    this.setState({ users: updatedUsers });
  };

  isUserOnline = (user) => user.status === "online";

  getKey(user) {
    return this.state.friends.find((f) => f.uid === user.uid).key;
  }

  getKeyForUnblock(user) {
    return this.state.blocked.find((f) => f.uid === user.uid).key;
  }

  isFriend(user) {
    return this.state.friends.some((f) => {
      return f.uid === user.uid;
    });
  }

  isBlocked(user) {
    return this.state.blocked.some((f) => {
      return f.uid === user.uid;
    });
  }

  // addFriend(user) {
  //   this.state.usersRef
  //     .child(`${this.state.user.uid}/friends`)
  //     .push()
  //     .update(user)
  //     .then(() => {
  //       console.log("Friend added");
  //       this.closeModal();
  //     })
  //     .catch((err) => console.error(err));
  // }

  removeFriend(user) {
    console.log(user.uid);
    this.state.usersRef
      .child(`${this.state.user.uid}/friends`)
      .child(`${this.getKey(user)}`)
      .remove()
      .then(() => {
        console.log("Friend removed");
      })
      .catch((err) => console.error(err));
  }

  unblock(user) {
    console.log(user.uid);
    this.state.usersRef
      .child(`${this.state.user.uid}/blocked`)
      .child(`${this.getKeyForUnblock(user)}`)
      .remove()
      .then(() => {
        console.log("Unblocked");
      })
      .catch((err) => console.error(err));
  }

  // updateFriend(user) {
  //   if (this.isFriend(user)) this.removeFriend(user);
  //   else this.addFriend(user);

  //   // console.log(user.uid)
  // }

  displayUsers() {
    let usersToDisplay = this.state.searchTerm
      ? this.state.searchResults
      : this.state.users;

    return usersToDisplay.length === 0
      ? ""
      : usersToDisplay.length >> 0 &&
          usersToDisplay.map(
            (user) =>
              !this.isBlocked(user) && (
                <React.Fragment>
                  <Feed>
                    <Feed.Event
                      key={user.uid}
                      //active={user.uid === activeChannel}
                    >
                      <Feed.Label image={user.avatar} />
                      <Feed.Content>
                        {this.isUserOnline(user) ? (
                          <Feed.Date style={{ color: "green" }}>
                            online
                          </Feed.Date>
                        ) : (
                          <Feed.Date style={{ color: "red" }}>
                            offline
                          </Feed.Date>
                        )}
                        <Feed.Summary>
                          <strong onClick={() => this.changeChannel(user)}>
                            {user.name}{" "}
                          </strong>
                          {this.isFriend(user) ? (
                            <Icon
                              name="remove"
                              color="red"
                              onClick={() => this.removeFriend(user)}
                            />
                          ) : (
                            <AddFriendButton
                              user={user}
                              currentUser={this.state.user}
                            />
                          )}
                        </Feed.Summary>
                      </Feed.Content>
                    </Feed.Event>
                  </Feed>
                </React.Fragment>
              )
            // <Item.Group>
            //   <Item
            //     key={user.uid}
            //     // active={user.uid === activeChannel}
            //   >
            //     <Item.Image size="mini" src={user.avatar} />

            //     <Item.Content verticalAlign="middle">
            //       <Item.Header>
            //         <Icon
            //           name="circle"
            //           color={this.isUserOnline(user) ? "green" : "red"}
            //         />
            //         {user.name}{" "}
            //         {this.isFriend(user) ?
            //             <Icon
            //             name="remove"
            //             color="red"
            //             onClick={() => this.removeFriend(user)}
            //             />
            //         : <AddFriendButton user={user} currentUser={this.state.user}/>
            //         }

            //       </Item.Header>
            //     </Item.Content>
            //   </Item>
            // </Item.Group>
            // <Menu.Item
            //   key={user.uid}
            //   // active={user.uid === activeChannel}

            //   style={{ opacity: 0.7, fontStyle: "italic" }}
            // >
            //   @ {user.name}
            //
            //   <hr/>
            // </Menu.Item>
          );
  }

  render() {
    const {
      users,
      // activeChannel,
      // searchTerm,
      searchLoading,
      //searchResults,
    } = this.state;

    return (
      <React.Fragment>
        <div>
          <Container>
            <Icon name="user" style={{ align: "middle" }} /> USERS (
            {users.length})
          </Container>
          <Input
            style={{ float: "left", marginTop: "10px", marginBottom: "10px" }}
            loading={searchLoading}
            onChange={this.handleSearchChange}
            size="mini"
            icon="search"
            name="searchTerm"
            placeholder="Search Users"
          />
        </div>
        <Menu.Menu className="menu">{this.displayUsers()}</Menu.Menu>
      </React.Fragment>
    );
  }
}

export default connect(null, { setCurrentChannel, setPrivateChannel })(
  SearchUsersComponent
);



// WEBPACK FOOTER //
// ./src/components/MetaPanel/SearchUsersComponent.js